// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusEnvelopeIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M11.3333 14.1663H4.66659C2.23325 14.1663 0.833252 12.7663 0.833252 10.333V5.66634C0.833252 3.23301 2.23325 1.83301 4.66659 1.83301H11.3333C13.7666 1.83301 15.1666 3.23301 15.1666 5.66634V10.333C15.1666 12.7663 13.7666 14.1663 11.3333 14.1663ZM4.66659 2.83301C2.75992 2.83301 1.83325 3.75967 1.83325 5.66634V10.333C1.83325 12.2397 2.75992 13.1663 4.66659 13.1663H11.3333C13.2399 13.1663 14.1666 12.2397 14.1666 10.333V5.66634C14.1666 3.75967 13.2399 2.83301 11.3333 2.83301H4.66659Z" fill={fill} />
      <path d="M7.9997 8.58C7.4397 8.58 6.87304 8.40667 6.43969 8.05333L4.35302 6.38665C4.13969 6.21331 4.09969 5.89998 4.27302 5.68665C4.44636 5.47331 4.75969 5.43331 4.97302 5.60665L7.0597 7.27333C7.56637 7.68 8.42637 7.68 8.93304 7.27333L11.0197 5.60665C11.233 5.43331 11.553 5.46665 11.7197 5.68665C11.893 5.89998 11.8597 6.21998 11.6397 6.38665L9.55304 8.05333C9.12637 8.40667 8.5597 8.58 7.9997 8.58Z" fill={fill} />
    </svg>
  );
};

export { StatusEnvelopeIcon };
